import type { CountryCode } from "./types"

export const COUNTRIES_SANCTIONED_BY_US: CountryCode[] = [
  "CU",
  "IR",
  "KP",
  "SY",
  "CN",
  "RU",
  "VE",
  "IQ",
  "MM",
]

export const NOT_AVAILABLE_TO_HIRE_COUNTRIES: CountryCode[] = []

export const PRIORITIZED_COUNTRIES: CountryCode[] = ["US", "GB"]

export const GLOBAL_SALARY_CONVERTER_SUPPORTED_COUNTRIES: CountryCode[] = [
  "BM",
  "CH",
  "NO",
  "IS",
  "BB",
  "JE",
  "IL",
  "DK",
  "BS",
  "SG",
  "GG",
  "HK",
  "LU",
  "AU",
  "JP",
  "IE",
  "NL",
  "NZ",
  "FR",
  "KR",
  "FI",
  "BE",
  "SE",
  "AT",
  "CA",
  "US",
  "GB",
  "LB",
  "MT",
  "MO",
  "PR",
  "IT",
  "SC",
  "DE",
  "QA",
  "TW",
  "CY",
  "AE",
  "PS",
  "MV",
  "GR",
  "CU",
  "TT",
  "BH",
  "SI",
  "ES",
  "EE",
  "YE",
  "UY",
  "SR",
  "PA",
  "BZ",
  "SA",
  "SN",
  "JM",
  "OM",
  "JO",
  "KH",
  "HR",
  "KW",
  "LV",
  "LY",
  "CZ",
  "PT",
  "ET",
  "CI",
  "CR",
  "ZW",
  "LT",
  "SK",
  "SV",
  "MU",
  "CL",
  "GT",
  "TH",
  "VE",
  "FJ",
  "ZA",
  "CN",
  "DO",
  "HU",
  "HN",
  "BW",
  "NI",
  "CM",
  "ME",
  "PL",
  "BG",
  "VN",
  "IR",
  "EC",
  "PH",
  "MY",
  "RS",
  "GH",
  "BA",
  "ID",
  "MM",
  "AL",
  "MX",
  "RU",
  "RO",
  "BO",
  "MN",
  "AR",
  "SO",
  "IQ",
  "KE",
  "AM",
  "MA",
  "UG",
  "BR",
  "BD",
  "ZM",
  "TZ",
  "PE",
  "RW",
  "MK",
  "LK",
  "BY",
  "UA",
  "NG",
  "MD",
  "PY",
  "GE",
  "AZ",
  "EG",
  "SY",
  "KZ",
  "TR",
  "NP",
  "TN",
  "UZ",
  "XK",
  "DZ",
  "CO",
  "IN",
  "AF",
  "PK",
]

export const SUBDIVISION_SPECIFIC_AGREEMENTS_COUNTRIES: CountryCode[] = ["US", "CA"]
